import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./styles.module.css";
import About3 from "Assets/About/about_3.png";
import Image1 from "Assets/About/about_1.png";
import About_2 from "Assets/About/about_2.png";
function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>Foreign Reporting</h3>
                </header>
                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <h3>
                            Stay Compliant with Foreign Bank Account Reporting
                        </h3>
                        <p>
                            If you hold financial accounts outside the United
                            States, the IRS requires you to file the{" "}
                            <b>Foreign Bank Account Report (FBAR)</b> annually
                            to disclose these assets. At Serene Tax, we simplify
                            the FBAR filing process, ensuring you meet all
                            compliance requirements while avoiding penalties for
                            late or inaccurate reporting.
                        </p>
                    </div>
                    <img src={Image1} alt="user" />
                </div>{" "}
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About_2} alt="user" />
                    <div className={AboutClasses["content"]}>
                        {/* <h5>Who we are</h5>{" "} */}
                        <h3>What is FBAR Filing?</h3>
                        <p>
                            FBAR, or FinCEN Form 114, is required for U.S.
                            citizens, residents, and entities with a financial
                            interest in or signature authority over foreign
                            financial accounts that exceed $10,000 at any time
                            during the calendar year. Filing the FBAR is crucial
                            to stay compliant with U.S. regulations and avoid
                            severe penalties.
                        </p>
                        <h4>Who Needs to File FBAR?</h4>
                        <p>
                            You must file an FBAR if you meet the following
                            criteria:
                        </p>
                        <p>
                            <b>U.S. Citizen or Resident:</b>This includes
                            individuals, corporations, partnerships, LLCs,
                            trusts, and estates.
                        </p>
                        <p>
                            <b>Foreign Financial Accounts:</b>
                            Accounts include bank accounts, brokerage accounts,
                            mutual funds, and other financial instruments held
                            outside the U.S
                        </p>
                        <p>
                            <b>$10,000 Threshold :</b> If the total value of all
                            foreign accounts exceeds $10,000 at any point during
                            the year, you are required to file.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Penalties for Non-Compliance</h3>
                        <p>
                            Failure to file an FBAR or reporting incorrect
                            information can result in severe penalties,
                            including:
                        </p>
                        <p>
                            <b>Civil Penalties:</b>
                            Up to $10,000 per non-willful violation, and higher
                            for willful violations.
                        </p>
                        <p>
                            <b>Criminal Penalties:</b>: Fines and potential
                            imprisonment for willful failure to file.
                        </p>
                        <p>
                            With <b>Serene Tax</b>, you can avoid these risks by
                            ensuring timely and accurate filing.
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Ensure Your Compliance Today!</h3>
                        <p>
                            Avoid penalties and streamline your FBAR filing
                            process with Serene Tax. Let us handle the
                            complexities so you can focus on what matters most
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default About;
